var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact_us"},[_c('div',{staticClass:"con_nav"},[_c('nav-tab',{attrs:{"nav-data":_vm.navData}})],1),_c('div',{staticClass:"con_center"},[_c('HowItem')],1),_c('div',{staticClass:"con_bottom"},[_c('layout-bottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }